module.exports = __webpack_public_path__ + "static/jonathan-livingston-seagull-8b3fe2444b500f093f40334dd7f0ddf0.jpg";